<template>
  <v-card outlined>
    <v-card-title>
      {{ subject.data.title }}
      <v-spacer></v-spacer>

      <v-dialog v-model="editDialogVisible" max-width="500px" @click:outside="$refs.editForm.reset()">
        <v-card outlined>
          <v-form ref="editForm">
            <v-card-title>
              Edit subject
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field 
                    v-model="title"
                    label="Title"
                    :rules="[inputRules.required]"
                    autofocus
                    @keydown.enter="updateSubject">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn depressed @click="updateSubject" :loading="submitting">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-icon small class="mr-2" @click="showEditDialog">
        edit
      </v-icon>
      <v-icon small @click="archiveSubject">
        delete
      </v-icon>
    </v-card-title>
    <v-card-text>
      <Tutorials :subject="subject"></Tutorials>
    </v-card-text>
  </v-card>
</template>

<script>
import Tutorials from './Tutorials'

export default {
  name: 'Subject',
  props: ['subject'],
  components: { Tutorials },
  data() {
    return {
      editDialogVisible: false,
      title: null,
      submitting: false,
      inputRules: {
        required: value => !!value || 'Required'
      }
    } 
  },
  methods: {
    showEditDialog() {
      // Copy from doc to local variables so
      // changes can be reverted
      this.title = this.subject.data.title
      this.editDialogVisible = true
    },
    async updateSubject() {
      if (this.$refs.editForm.validate()) {
        this.submitting = true
        // Copy changes from local variables to the object
        this.subject.data.title = this.title
        // Update Firestore
        await this.$store.dispatch('updateSubject', this.subject)
        
        this.$refs.editForm.reset()
        this.submitting = false
        this.editDialogVisible = false
      }
    },
    async archiveSubject() {
      const res = await this.$confirm('Are you sure you want to archive "' + this.subject.data.title + '"?')
      if (res === true) {
        this.subject.data.isArchived = true
        await this.$store.dispatch('updateSubject', this.subject)
      }
    }}
}
</script>

<style scoped>

</style>
        